import { call, put, takeEvery } from 'typed-redux-saga'
import { errorHandler, regionByIpApi, RegionByIpNs, regionByIpSlice } from 'Modules'

export function* getRegionByIpSaga(action: RegionByIpNs.GetRegion) {
	try {
		const ip = yield* call(regionByIpApi.getIp)
		const address = yield* call(regionByIpApi.getDadataAddressByIp, ip)
		const regions = yield* call(regionByIpApi.getRegions)
		const nameRegion = address.location?.data.region || ''
		const nameRegionType = address.location?.data.region_type_full || ''
		const preparedRegionName = `${nameRegion} ${nameRegionType}`.toLocaleLowerCase().trim()
		const fullRegion = (regions?.entries ?? []).find(
			(region) => region.name.toLocaleLowerCase() === preparedRegionName
		)
		yield* put(regionByIpSlice.actions.setRegion(fullRegion))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* regionByIpSaga() {
	yield* takeEvery(regionByIpSlice.actions.getRegion.type, getRegionByIpSaga)
}
